import React, { FC, memo, useEffect } from "react";
import { Container } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import LoadingBar from "../../components/LoadingBar/LoadingBar";
import injectReducer from "../../reduxFolder/injectReducer";
import containersReducer, {
  getContainers,
} from "../../reduxFolder/reducers/containers";
import storageReducer from "../../reduxFolder/reducers/storage";
import { authSelectUnits } from "../../reduxFolder/selectors/globalSelectors";
import {
  containersSelectItems,
  containersSelectLoading,
} from "../../reduxFolder/selectors/containersSelectors";
import { toastResponseError } from "../../utils/responseMessageHelper";
import ContainerRow from "./components/ContainerRow/ContainerRow";
import { ContainersEmpty, Wrapper } from "./Containers.styles";

interface ContainersProps {
  items: any;
  units: string;
  isLoading: boolean;
  getContainers: () => Promise<any>;
}

const Containers: FC<ContainersProps> = ({
  items,
  units,
  isLoading,
  getContainers,
}) => {
  const { t } = useTranslation("common");
  const hasItems = items.size > 0;

  useEffect(() => {
    getContainers().catch(toastResponseError);
  }, [getContainers]);

  return (
    <Wrapper>
      <Container fluid>
        <LoadingBar isLoading={isLoading} isCartLoading={false} />
        {!isLoading &&
          hasItems &&
          items.map((container: any) => (
            <ContainerRow
              key={container.get("id")}
              container={container}
              units={units}
            />
          ))}
        {!isLoading && !hasItems && (
          <ContainersEmpty>{t("containers.emptyList")}</ContainersEmpty>
        )}
      </Container>
    </Wrapper>
  );
};

const withReducer = injectReducer({
  key: "containers",
  reducer: containersReducer,
});

// Shipments opened from a container render in StorageItemPanel, which fetches
// into the storage slice — same reason Inventory injects it.
const withStorageReducer = injectReducer({
  key: "storage",
  reducer: storageReducer,
});

const withConnect = connect(
  createStructuredSelector({
    units: authSelectUnits,
    items: containersSelectItems,
    isLoading: containersSelectLoading,
  }),
  {
    getContainers,
  },
);

const enhance = compose(withReducer, withStorageReducer, withConnect, memo);

export default enhance(Containers);
